import { Grid, GridItem, Text } from "@chakra-ui/react";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { AuthMode, FilterSet } from "@nens/ldo/api-v1";

import { Facet } from "../facet/facet";
import { FromToFacet } from "../from-to-facet/from-to-facet";

import { ModeToggler } from "./mode-toggler";

interface FilterTreeProps {
  authMode: AuthMode;
  setAuthMode: (authMode: AuthMode) => void;
  filters: FilterSet;
  setFilters: React.Dispatch<React.SetStateAction<FilterSet>>;
}

export function FilterTree({ authMode, setAuthMode, filters, setFilters }: FilterTreeProps) {
  const intl = useIntl();

  // Make this depend on mode and chosen filters
  const publicFacets = [
    {
      title: intl.formatMessage({ id: "filtertree.areaname", defaultMessage: "Area name" }),
      field: "gebiedsnaam",
    },
    {
      title: intl.formatMessage({
        id: "filtertree.breachlocation",
        defaultMessage: "Breach location",
      }),
      field: "naam doorbraaklocatie",
    },
    {
      title: intl.formatMessage({
        id: "filtertree.externalwater",
        defaultMessage: "External water",
      }),
      field: "naam buitenwater",
    },
    {
      title: intl.formatMessage({ id: "filtertree.frequency", defaultMessage: "Frequency" }),
      field: "overschrijdingsfrequentie",
    },
  ];

  const privateFacets = [
    {
      title: intl.formatMessage({ id: "filtertree.status", defaultMessage: "Status" }),
      field: "status",
    },
    ...publicFacets,
  ];

  const facets = authMode === "public" ? publicFacets : privateFacets;

  return (
    <Grid w="full" my="4" mx="0" border="1px" borderColor={"gray.200"} rounded="6px">
      <GridItem px="8px" py="4px" borderBottom="1px" borderColor={"gray.200"}>
        <Text fontSize="md" fontWeight="semibold">
          <FormattedMessage id="filtertree.auth_mode" defaultMessage="Visibility" />:
        </Text>
      </GridItem>
      <GridItem px="8px" py="12px" borderBottom="1px" borderColor={"gray.200"}>
        <ModeToggler authMode={authMode} setAuthMode={setAuthMode} />
      </GridItem>
      <GridItem px="8px" py="4px" borderBottom="1px" borderColor={"gray.200"}>
        <Text fontSize="md" fontWeight="semibold">
          <FormattedMessage id="filtertree.filter_on" defaultMessage="Filter on:" />
        </Text>
      </GridItem>
      {facets.map((facet) => (
        <Facet
          key={facet.field}
          authMode={authMode}
          title={facet.title}
          filter={facet.field}
          filters={filters}
          setFilters={setFilters}
        />
      ))}
      <FromToFacet
        title={intl.formatMessage({ id: "filtertree.created_at", defaultMessage: "Created at" })}
        filter="created_at"
        filters={filters}
        setFilters={setFilters}
      />
    </Grid>
  );
}
